<template>
    <div>
        <compFormEdit v-if="typeform==='pushyuncang'" class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" :labelWidth="80" :col="1"></compFormEdit>
        <compFormEdit v-if="typeform==='replenishment'" class="margin-top-15 margin-right-15" :formdata="getReplenishment" v-model="formData" :labelWidth="130" :col="1"></compFormEdit>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
            <vButton class="margin-left-5" @click="close">{{$t('global.common.cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpPushWarehouse,
    HttpBatchReplenishment,
} from '@/service/products/allproducts'

export default {
    props:['params','typeform'],
    data(){
        return {
            formData:{
                status:1
            },
        }
    },
    components: {
		compFormEdit: () => import("@components/templates/formedit"),
    },
    computed:{
        ...mapGetters('diction',['getNewWarehouseIdList']),
        getWarehouse(){
            return this.getNewWarehouseIdList.filter(item=>{
                return item.attach.item.warehouseType ==1 || item.attach.item.warehouseType ==5
            })
        },
        getBase(){
            return [
                {
                    label: this.$t('global.common.warehouse',{defaultValue:'仓库'}),
					key: "orgWarehouseIds",
					tag: "vSelect",
					options: this.getWarehouse,
					props: {
                        filterable: true,
                        multiple: true,
					},
                }
            ]
        },
        getReplenishment(){
            return [
                {
					label: "批量修改补货状态",
					key: "status",
					tag: "vRadio",
					required: false,
					options: [{
						trueValue: 1,
						label: '不再补货'
					}, {
						trueValue: 0,
						label: '正常补货'
					}],
                },
            ]
        }
    },
    methods:{
        submit(){
            console.log(this.params)
            if(this.typeform === 'pushyuncang'){
                HttpPushWarehouse({
                    ids:this.params,
                    orgWarehouseIds:this.formData.orgWarehouseIds
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.$emit('on-update');
                    this.close();
                })
            }else if(this.typeform === 'replenishment'){
                HttpBatchReplenishment({
                    ids:this.params,
                    status:this.formData.status
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.$emit('on-update');
                    this.close();
                })
            }
        },
        close(){
            this.$emit('on-close')
        }
    }
}
</script>